import { render } from "./BatchSizeTableEditor.vue?vue&type=template&id=c2abd262&scoped=true"
import script from "./BatchSizeTableEditor.vue?vue&type=script&lang=js"
export * from "./BatchSizeTableEditor.vue?vue&type=script&lang=js"

import "./BatchSizeTableEditor.vue?vue&type=style&index=0&id=c2abd262&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2abd262"]])

export default __exports__